import { createReducer } from '@reduxjs/toolkit'

import {
    PARTICIPANT_CASE_REQUEST,
    PARTICIPANT_CASE_SUCCESS,
    PARTICIPANT_CASE_FAILURE,
} from '../actions/types'

const initialState = {
    data: null,
    isLoading: true,
    error: null,
}

export default createReducer(initialState, {
    [PARTICIPANT_CASE_REQUEST]: (state) => {
        state.isLoading = true
    },
    [PARTICIPANT_CASE_SUCCESS]: (state, action) => {
        state.data = action.payload
        state.isLoading = false
        state.error = false
    },
    [PARTICIPANT_CASE_FAILURE]: (state, action) => {
        state.data = null
        state.isLoading = false
        state.error = action.payload
    },
})
